<template>
  <v-container>
    <v-dialog
        v-model="dialog"
        width="600"
        >
        <div :style="'height:' + heightPanel + 'px; background:white'">
      <!--
        <v-card>
            <v-card-title
            class="headline grey lighten-2 opensansregular size10"
            primary-title
            >
            Territorial level
            </v-card-title>
            <v-card-text class="opensansregular  size10">
      -->
                <h3 class="blue pa-3 white--text">Choose territorial level</h3>
                <v-radio-group v-model="radioGroup" class="white opensansregularcase size8 ml-3">
                        <v-radio
                        v-for="level in territorial_levels" :key="level.id"
                        :label="level.name"
                        :value="level.id"
                        class="size8 opensansregularcase"
                        v-on:change="confirmLevel(level.id)"
                        ></v-radio>
                    </v-radio-group>
                    <div v-if="this.$store.getters.TL === 'EFUA' || this.$store.getters.TL === 'CY' ||  this.$store.getters.TL === 'FUA'" class="opensansregularcase size9 ml-3 mr-3">
                      <b>(i)</b> 
                      a Functional Urban Area (FUA) consists of a densely inhabited city and its surrounding, less densely populated local units that are part of the city’s labour market (‘commuting zone’). 
                      <br/><a href="https://doi.org/10.1787/d58cb34d-en" target="_new">More information available at https://doi.org/10.1787/d58cb34d-en</a><br>
                    </div>
                    <div v-if="this.$store.getters.TL === 'EFUA' || this.$store.getters.TL === 'CY' || this.$store.getters.TL === 'FUA'" class="opensansregularcase size9 ml-3 mr-3 mt-2">
                      <b>(ii)</b> 
                      a grid-based Functional Urban Area (eFUA) is delineated from a population grid and it is not adapted to local units defined according to administrative or statistical purposes.
                      <br/><a href="https://doi.org/10.1016/j.jue.2020.103242" target="_new">More information are available at https://doi.org/10.1016/j.jue.2020.103242</a>
                    </div>

      <!--
            </v-card-text>
        </v-card>
      -->
        </div>
      </v-dialog>
  </v-container>
</template>

<script>
export default {
    icons: {
      iconfont: 'mdi', // default - only for display purposes
    },
    name: 'LevelSelector',
    props: {show: Boolean},
    watch: {
      show: function () {
          this.dialog = true
      },
      '$store.getters.TL': function () {
        //console.log('TL Changed')
        this.setTerritorialLevels()
      }
    },    
    methods: {
      setTerritorialLevels: function() {
        let tl = this.$store.getters.TL
        if (tl === 'EFUA' || tl === 'FUA' || tl === 'CY')
          {
          this.territorial_levels = this.$store.getters.territorial_levels_C
          this.heightPanel = '350'
          }
        else
          {
          this.territorial_levels = this.$store.getters.territorial_levels_R
          }
          this.radioGroup = tl
          //console.log(this.territorial_levels)
      },
      showIndicator: function () {
        this.overlay = true
      },
      confirmLevel: function (id) {
        //console.log(id)
        this.dialog = false
        let params = this.$route.params
        let query = this.$route.query
        //console.log(params)
        params.tl = id
        params.year = 'x'
        params.tu = 'x'
        params.c = 'x'
        if (id !== 'TL2' && id !== 'TL3') {
          params.indicod = 'x'
        }
        //console.log("Router replace Home")
        //console.log(params)
        this.$router.replace({ name: 'Home', params: params, query: query})
        return
      }
    },
    mounted () {
      this.dialog = this.show
    },
    data: () => ({
        radioGroup: 1,
        territorial_levels: [],
        heightPanel: '170',
      dialog: false,
    })
    
}
</script>
